import { Stack, Typography } from '@mui/material';
import { ControlledSelectInput2 } from 'Components';
import { DatePicker } from 'Components/DatePicker';
import { SimpleToggle } from 'Components/SimpleToggle';
import { defaultMinDate } from 'Config';
import { AppliesContext } from 'Context/AppliesContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext } from 'react';

export const SecondSegment = () => {
  const {
    applications,
    filtersData,
    isFilterByYear,
    setIsFilterByYear,
    setFiltersData,
  } = useContext(AppliesContext);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Applies);
  const isDesktop = useIsDesktop();

  const getAllRequestYears = () =>
    [
      ...new Set(
        applications
          .map((application) =>
            application.createDate
              ? new Date(application.createDate).getFullYear()
              : undefined
          )
          .filter((createDate) => !!createDate)
      ),
    ]
      .sort((a, b) => b! - a!)
      .map((year) => year!.toString());

  return (
    <fieldset>
      <Stack>
        <Typography
          component='legend'
          display='block'
          fontWeight='700'
          mb='16px'
        >
          {dictionary.requestOpenDate}
        </Typography>
        <Stack
          direction={isDesktop ? 'row' : 'column'}
          gap={isDesktop ? '48px' : '24px'}
          alignItems={'flex-end'}
        >
          <SimpleToggle
            option1={dictionary.betweenDates}
            option2={dictionary.byYear}
            setState={(isOption1Selected) =>
              setIsFilterByYear(!isOption1Selected)
            }
            isOption2={isFilterByYear}
          />
          {isFilterByYear ? (
            <ControlledSelectInput2
              disablePortal={isDesktop ? false : true}
              label={dictionary.year}
              options={getAllRequestYears()}
              value={filtersData.year}
              onChange={(e) =>
                setFiltersData({ ...filtersData, year: e.target.value })
              }
              size={'small'}
            />
          ) : (
            <Stack
              flexDirection={isDesktop ? 'row' : 'column'}
              rowGap={isDesktop ? undefined : '28px'}
              alignItems='center'
              justifyContent='flex-end'
              gap='20px'
              mt='-4px'
              sx={{
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(23, 82, 175, 0.2)',
                },
                '.MuiInputLabel-shrink': { color: '#1752AF', mt: '4px' },
              }}
            >
              <DatePicker
                label={dictionary.fromDate}
                maxDate={filtersData.to || new Date(Date.now())}
                minDate={defaultMinDate}
                onChange={(value) =>
                  setFiltersData({
                    ...filtersData,
                    from: value,
                  })
                }
                value={filtersData.from}
              />
              <DatePicker
                label={dictionary.toDate}
                maxDate={new Date(Date.now())}
                minDate={filtersData.from || defaultMinDate}
                onChange={(value) =>
                  setFiltersData({
                    ...filtersData,
                    to: value,
                  })
                }
                value={filtersData.to}
              />
            </Stack>
          )}
        </Stack>
      </Stack>
    </fieldset>
  );
};
